const header_operlay = document.querySelector("[data-banner-header-overlay]");
if(header_operlay){
  document.body.classList.add('header-overlay');
}

// accordions js start
function faq_taggol() {
  const accordions = document.querySelectorAll("[js-acc-item]");
  const openAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.add("active");
    content.style.maxHeight = 'max-content';
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector("[js-acc-single-content]");
    accordion.classList.remove("active");
    if(content){
      content.style.maxHeight = null;
    }
  };
  
  accordions.forEach((accordion) => {
    const intro = accordion.querySelector("[js-acc-single-trigger]");
    const content = accordion.querySelector("[js-acc-single-content]");
    if(intro){
        intro.onclick = (e) => {
          if (content.style.maxHeight) {
            closeAccordion(accordion);
          } else {
            accordions.forEach((accordion) => closeAccordion(accordion));
            openAccordion(e.target.closest('[js-acc-item]'));
          }
        };
    }
  });   
}
// accordions js end
(function() {
  faq_taggol();
})();


// ====== faq page accordian  ======
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".faq-page_main_wrapper .accordion").forEach(function (accordion) {
    accordion.addEventListener("click", function () {
      const isOpen = accordion.classList.contains("is-open");
      document.querySelectorAll(".faq-page_main_wrapper .accordion").forEach(function (item) {
        item.classList.remove("is-open");
        const content = item.nextElementSibling;
        if (content) content.style.maxHeight = "0px";
      });
      if (!isOpen) {
        accordion.classList.add("is-open");
        const content = accordion.nextElementSibling;
        if (content) content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });
});

// -------------- faq page  js
const faqtitle = document.querySelectorAll('.faq-btn');
faqtitle.forEach(faqtitles => {
  faqtitles.addEventListener('click', function (event) {
    event.preventDefault();

    const gettitle = this.getAttribute('data-btn-title');
    faqtitle.forEach(btn => btn.classList.remove('active'));
    this.classList.add('active');


    document.querySelectorAll('.faq-page-content').forEach(content => {
      content.style.display = "none";
    });

    const contentdiv = document.querySelector(`.faq-page-content[data-faq-content="${gettitle}"]`);

    if (contentdiv) {
      contentdiv.style.display = "block";
    }
   const classremove  =  document.querySelector('.dropdown-content');
    classremove.classList.remove('dropdown-active')
  });
});

document.querySelectorAll('.dropdown-button').forEach(dropdownBtn => {
  dropdownBtn.addEventListener('click', function (event) {
    event.stopPropagation(); // Prevents immediate closing when clicking button

    const closestDiv = this.closest('.dropdown');
    const dropdownContent = closestDiv.querySelector('.dropdown-content');

    // Close all other dropdowns
    document.querySelectorAll('.dropdown-content').forEach(content => {
      if (content !== dropdownContent) {
        content.classList.remove('dropdown-active');
      }
    });

    dropdownContent.classList.toggle('dropdown-active');
  });
});

document.addEventListener('click', function (event) {
  document.querySelectorAll('.dropdown-content').forEach(content => {
    if (!content.closest('.dropdown').contains(event.target)) {
      content.classList.remove('dropdown-active');
    }
  });
});

function toggleDropdown() {
  var dropdownMenu = document.getElementById("dropdownMenu");
  var dropdownIcon = document.getElementById("right-arrow");

  if (dropdownMenu.style.display === "block") {
    dropdownMenu.style.display = "none";
    dropdownIcon.style.transform = "rotate(0deg)";
  } else {
    dropdownMenu.style.display = "block";
    dropdownIcon.style.transform = "rotate(180deg)";
  }
}

document.addEventListener("DOMContentLoaded", function () {
  var activeTab = document.querySelector(".faq-btn.active");
  var dropdownLabel = document.getElementById("dropdownLabel");

  // Page load → active tab no text show karvo
  if (activeTab) {
    dropdownLabel.textContent = activeTab.textContent;
  }

  // Click event → active change & label update
  document.querySelectorAll(".faq-btn").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();

      document.querySelectorAll(".faq-btn").forEach(function (el) {
        el.classList.remove("active");
      });
      btn.classList.add("active");

      dropdownLabel.textContent = btn.textContent;

      document.getElementById("dropdownMenu").style.display = "none";
      document.getElementById("right-arrow").style.transform = "rotate(0deg)";
    });
  });
});


// =========product tab section

 const tabs = document.querySelectorAll(".product-tab-section ul li");
      const contents = document.querySelectorAll(".tabproduct-list");

      if (tabs.length > 0) {
        tabs.forEach(tab => {
          tab.addEventListener("click", function () {
            const target = this.getAttribute("data-title");

            tabs.forEach(t => t.classList.remove("active"));
            contents.forEach(c => c.classList.remove("active_content"));

            this.classList.add("active");
            const activeContent = document.querySelector(`.tabproduct-list[data-content="${target}"]`);
            if (activeContent) {
              activeContent.classList.add("active_content");
            }
          });
        });
      }



// ================== main blog page

const wrappers = document.querySelectorAll(".video-wrapper");

if (wrappers.length > 0) {
  let currentlyPlaying = null; // track currently playing video

  wrappers.forEach((wrapper) => {
    const videoe = wrapper.querySelector("video");
    const playBtn = wrapper.querySelector(".playBtn");

    // Play button click
    playBtn.addEventListener("click", () => {
      // pause any other video
      if (currentlyPlaying && currentlyPlaying !== videoe) {
        currentlyPlaying.pause();
        currentlyPlaying.removeAttribute("autoplay"); // stop autoplay on prev video
        const prevBtn = currentlyPlaying.closest(".video-wrapper").querySelector(".playBtn");
        if (prevBtn) prevBtn.style.display = "block";
      }

      // enable autoplay for this video
      videoe.setAttribute("autoplay", "true");
      videoe.play();

      playBtn.style.display = "none";
      currentlyPlaying = videoe;
    });

    // When video ends → show play button again
    videoe.addEventListener("ended", () => {
      playBtn.style.display = "block";
      videoe.removeAttribute("autoplay"); // reset autoplay
      currentlyPlaying = null;
    });
  });
}

//  timer workshop

  function updateCountdown() {
  const countdown = document.getElementById("countdown");
  if (!countdown) return;

  const startDateStr = countdown.getAttribute("data-start_date");
  const endDateStr = countdown.getAttribute("data-end_date");

  const startDate = new Date(startDateStr).getTime();
  const endDate = new Date(endDateStr).getTime();
  const now = new Date().getTime();

  let distance;

  // If start date is in the future → countdown to START
  if (now < startDate) {
    distance = startDate - now; 
  } 
  // If between start and end → countdown to END
  else {
    distance = endDate - now;
  }

  if (distance < 0) {
    // Time completed
    return;
  }

  const days = String(Math.floor(distance / (1000 * 60 * 60 * 24))).padStart(2, '0');
  const hours = String(Math.floor((distance / (1000 * 60 * 60)) % 24)).padStart(2, '0');
  const minutes = String(Math.floor((distance / (1000 * 60)) % 60)).padStart(2, '0');
  const seconds = String(Math.floor((distance / 1000) % 60)).padStart(2, '0');

  function renderDigits(containerId, value) {
    const container = document.getElementById(containerId);
    if (!container) return;

    container.innerHTML = '';
    for (let digit of value) {
      const span = document.createElement('span');
      span.textContent = digit;
      container.appendChild(span);
    }
  }

  renderDigits('days', days);
  renderDigits('hours', hours);
  renderDigits('minutes', minutes);
  renderDigits('seconds', seconds);
}

setInterval(updateCountdown, 1000);
updateCountdown();


  // Initial call
  updateCountdown();

  // Update every second
  setInterval(updateCountdown, 1000);


const worktabs = document.querySelectorAll('.workshop-tabs ul li');

if (worktabs.length > 0) {
  worktabs.forEach(tab => {
    tab.addEventListener('click', function () {
      const selectedTitle = this.getAttribute('data-title');

      // Remove active from all boxes
      document.querySelectorAll('.Wtabs-content').forEach(box => {
        box.classList.remove('active');
      });

      // Match workshop-wrap
      const matchBox = document.querySelector(`.Wtabs-content[data-title="${selectedTitle}"]`);
      if (matchBox) {
        matchBox.classList.add('active');
      }

      // Tab active styling
      worktabs.forEach(li => li.classList.remove('active'));
      this.classList.add('active');
    });
  });
}


// ==================== body on class add
window.addEventListener('scroll', function() {
  const header = document.querySelector('header');
  if (window.scrollY > 0) {
    document.querySelector('body').classList.add('header_sticky');
  } else {
    document.querySelector('body').classList.remove('header_sticky');
  }
});




// --------------- pdp media mobile view

if (window.matchMedia) {
  const mq = window.matchMedia("(min-width: 1000px)");
  mq.addListener(handleWidthChange);
  handleWidthChange(mq);
}

function handleWidthChange(mq) {
  const sliderEl_div = document.querySelector('[data-main-pdp-swiper]');
  if (!sliderEl_div) return; // exit if no slider on this page

  const sliderEl = document.querySelector('[data-pdp-main-slider]');
  if (!sliderEl) return;

  const optionsAttr = sliderEl.getAttribute('data-slider-options');

  if (mq.matches) {
    // Desktop: destroy swiper if exists
    if (sliderEl_div.swiper) {
      sliderEl_div.swiper.destroy(true, true);
    }
  } else {
    // Mobile: initialize swiper if not already initialized
    if (!sliderEl_div.swiper) {
      if (optionsAttr) {
        const options = JSON.parse(optionsAttr);
        new Swiper(sliderEl_div, options);
      }
    }
  }
}


const balanceItems = document.querySelectorAll('.balance-detail-block-item-inner');
  if (balanceItems.length > 0) {
  balanceItems.forEach(item => {
    item.addEventListener('mouseenter', () => {
        item.classList.remove('active');
        document.querySelectorAll('.balance-detail-block-item-inner').forEach(activeEl => {
          activeEl.classList.remove('active');
        });
    });
  });
}


document.addEventListener("click", (e) => {
  const activeMenu = e.target.closest(".panel-list__wrapper li.active-menu");
  const navDrawer = document.querySelector("navigation-drawer");

  if (activeMenu && navDrawer) {
    // Remove 'open' attribute
    navDrawer.removeAttribute("open");

    // Apply hiding styles
    navDrawer.style.left = "auto";
    navDrawer.style.right = "0px";
    navDrawer.style.bottom = "0px";
    navDrawer.style.opacity = "0";
    navDrawer.style.visibility = "hidden";
  }
});


function openPopup(popupId) {
  document.querySelector(popupId)?.classList.add('active');
}

function closePopup(el) {
  el.closest('.popup-overlay')?.classList.remove('active');
}